import { axiosPrivate } from "../../api/axios";
import handleError from "../../hooks/handleError";


// Save Accounts ("Save Changes")
const saveAppAccounts = (AppAccounts) => {

    let isMounted = true;
    const controller = new AbortController();

    const AppAccountsToInsert = AppAccounts.filter((row) => row.actions === "INSERT");
    const AppAccountsToUpdate = AppAccounts.filter((row) => row.actions === "UPDATE");
    const AppAccountsToDelete = AppAccounts.filter((row) => row.actions === "DELETE");

    const insertAppAccounts = async (AppAccountsToInsert) => {
        try {
            await axiosPrivate.post("/Settings/create/app-accounts",
                AppAccountsToInsert,
                { signal: controller.signal }
            );
        } catch (err) {
            handleError(err);
        }

        return () => {
            isMounted = false;
            controller.abort();
        }
    }

    const updateAppAccounts = async (AppAccountsToUpdate) => {
        try {
            await axiosPrivate.post("/Settings/update/app-accounts",
                AppAccountsToUpdate,
                { signal: controller.signal }
            );
        } catch (err) {
            handleError(err);
        }

        return () => {
            isMounted = false;
            controller.abort();
        }
    }

    const deleteAppAccounts = async (AppAccountsToDelete) => {
        try {
            await axiosPrivate.post("/Settings/delete/app-accounts",
                AppAccountsToDelete,
                { signal: controller.signal }
            );
        } catch (err) {
            handleError(err);
        }

        return () => {
            isMounted = false;
            controller.abort();
        }
    }

    if (AppAccountsToDelete.length > 0) { deleteAppAccounts(AppAccountsToDelete) };
    if (AppAccountsToInsert.length > 0) { insertAppAccounts(AppAccountsToInsert) };
    if (AppAccountsToUpdate.length > 0) { updateAppAccounts(AppAccountsToUpdate) };


};
export default saveAppAccounts